import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n.js';
import '@/assets/css/reset.css';
import App from './App.js';
import { Provider } from 'react-redux';
import store from './store/index.js';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
